export enum SortDirectionsEnum {
    Asc = 0,
    Desc = 1,
}
